import { api } from "@/lib/api";

export function irAGenerados(nav, generados, { abrirEmail = true } = {}) {
  sessionStorage.setItem("deca_ultimos_generados", JSON.stringify(generados || []));
  if (abrirEmail) sessionStorage.setItem("deca_abrir_email", "1");
  else sessionStorage.removeItem("deca_abrir_email");
  nav("/decas/generados");
}

export function decaToGenerado(d) {
  return {
    deca_id: d.id || d.deca_id,
    numero_deca: d.numero_deca,
    download_token: d.download_token,
    public_url: d.public_url,
    num_envios: d.num_envios,
    cargador: d.cargador_snapshot || d.cargador || {},
    transportista: d.transportista_snapshot || d.transportista || {},
    fecha_transporte: d.fecha_transporte,
    matriculas: d.matriculas || [],
    estado: d.estado,
    fuente: d.fuente,
  };
}

export async function recuperarGeneradosRecientes({ transportistaNif, fecha, fuente } = {}) {
  const { data } = await api.get("/api/v1/decas", { params: { limit: 8 } });
  const items = data.items || [];
  const now = Date.now();
  const nifWanted = (transportistaNif || "").toUpperCase();
  const fechaWanted = fecha ? String(fecha).slice(0, 10) : "";
  return items
    .filter((d) => {
      if (d.estado === "anulado") return false;
      const ts = Date.parse(d.created_at || "") || 0;
      if (!ts || now - ts > 4 * 60 * 1000) return false;
      if (nifWanted) {
        const nif = (d.transportista_nif || d.transportista_snapshot?.nif || "").toUpperCase();
        if (nif !== nifWanted) return false;
      }
      if (fechaWanted && d.fecha_transporte && String(d.fecha_transporte).slice(0, 10) !== fechaWanted) {
        return false;
      }
      if (fuente && d.fuente && d.fuente !== fuente) return false;
      return true;
    })
    .map(decaToGenerado);
}

function esErrorRedOTimeout(e) {
  const status = e?.response?.status;
  if (status === 502 || status === 503 || status === 504) return true;
  const code = e?.code || "";
  if (code === "ECONNABORTED" || code === "ERR_NETWORK") return true;
  const msg = String(e?.message || e?.response?.data?.detail || "").toLowerCase();
  return msg.includes("timeout") || msg.includes("network") || msg.includes("504") || msg.includes("502") || msg.includes("econnreset");
}

function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

export async function postGenerarConRecuperacion(path, payload, match) {
  try {
    const { data } = await api.post(path, payload, { timeout: 90000 });
    const gens = data.generados || [];
    if (gens.length) return { generados: gens, recuperado: false };
  } catch (e) {
    if (!esErrorRedOTimeout(e)) throw e;
    for (let i = 0; i < 4; i += 1) {
      await sleep(1500 + i * 800);
      const rec = await recuperarGeneradosRecientes(match);
      if (rec.length) return { generados: rec, recuperado: true };
    }
    throw e;
  }
  const rec = await recuperarGeneradosRecientes(match);
  if (rec.length) return { generados: rec, recuperado: true };
  throw new Error("No se recibi" + "\u00f3" + " el DeCA generado");
}
